import { createSlice, PayloadAction } from "@reduxjs/toolkit"

/**
 * -1: not in the reset password flow
 * 0: change password bottom sheet is open --> logged-in user
 * 1: send otp bottom sheet is open --> both logged-in and logged-out user
 * 2: reset password bottom sheet is open --> both logged-in and logged-out user
 */
type ResetPasswordFlowStep = -1 | 0 | 1 | 2;

type ResetPasswordSlice = {
  step: ResetPasswordFlowStep;
  showPasswordChangedSuccessfullyModal: boolean;
  showNoEmailFoundModal: boolean;
  forgetPasswordToken: string | null;
  resendOTPRemainedTime: number | null;
  email: string;
}

const initialState = {
  step: -1,
  showPasswordChangedSuccessfullyModal: false,
  showNoEmailFoundModal: false,
  forgetPasswordToken: null,
  resendOTPRemainedTime: null,
  email: ""
} as ResetPasswordSlice

export const resetPassword = createSlice({
  name: "resetPassword",
  initialState: initialState,
  reducers: {
    updateForgetPasswordStep: (state, action: PayloadAction<ResetPasswordFlowStep>) => {
      if (action.payload === -1) {
        return structuredClone(initialState)
      } else {
        const prevStep = state.step
        if (action.payload === 1 && prevStep === 2) {
          state.forgetPasswordToken = initialState.forgetPasswordToken
          state.resendOTPRemainedTime = initialState.resendOTPRemainedTime
        }
        state.step = action.payload
      }
    },
    updateShowPasswordChangedSuccessfullyModal: (state) => {
      const prevValue = state.showPasswordChangedSuccessfullyModal
      state.showPasswordChangedSuccessfullyModal = !prevValue
      state.step = -1
      state.forgetPasswordToken = null
      state.resendOTPRemainedTime = null
      state.email = ""
      if (!prevValue) {
        state.showNoEmailFoundModal = false
      }
    },
    updateShowNoEmailFoundModal: (state) => {
      const prevValue = state.showNoEmailFoundModal
      state.showNoEmailFoundModal = !prevValue
      state.step = -1
      if (!prevValue) {
        state.showPasswordChangedSuccessfullyModal = false
      }
    },
    updateForgetPasswordResult: (state, action: PayloadAction<ForgetPasswordResponseDto>) => {
      state.forgetPasswordToken = action.payload.token
      state.resendOTPRemainedTime = action.payload.timestamp
    },
    updateEmail: (state, action: PayloadAction<string>) => {
      state.email = action.payload
    }
  }
})

export const {
  updateForgetPasswordStep,
  updateShowPasswordChangedSuccessfullyModal,
  updateShowNoEmailFoundModal,
  updateForgetPasswordResult,
  updateEmail
} = resetPassword.actions

export default resetPassword.reducer
